require("../sass/style.scss");
require("../fonts/fontello/css/fontello.css");
require("./vendor/jquery-filer/css/jquery.filer.css");
import 'video.js/dist/video-js.css';

require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");
require("./vendor/li-marquee");
require("./vendor/select2.full");
import 'flatpickr/dist/flatpickr.css';
// require("./vendor/hyphenopoly/Hyphenopoly_Loader");
require("./vendor/jquery.inputmask");
require("./vendor/jquery-filer/js/jquery.filer");

import "swiper/css/bundle";

require("./custom/header.es6");
require("./custom/tag-managers.es6");
require("./custom/anchor.es6");

(function ($) {
    $(".collapse-repeater-support").length > 0 && require("./custom/single-support-center.es6");
    $(".header-banner").length > 0 && require("./custom/banner.es6");
    if($(".multi-step_form_preview").length > 0) {
        require("./vendor/validation/jquery.validate");
        require("./page_builder/section_multi-step_form_preview.es6");
    }
    $(".tooltip-popup, .tariff-api").length > 0 && require("./page_builder/section_tooltip_popup.es6");
    $(".section-trust-block").length > 0 && require("./page_builder/section_trust_block.es6");
    $(".section-slider-type-1").length > 0 && require("./page_builder/section_slider_type_1.es6");
    $(".section-slider-type-2").length > 0 && require("./page_builder/section_slider_type_2.es6");
    $(".section-slider-type-3").length > 0 && require("./page_builder/section_slider_type_3.es6");
    $(".section-slider-type-4").length > 0 && require("./page_builder/section_slider_type_4.es6");
    $(".section-slider-type-5").length > 0 && require("./page_builder/section_slider_type_5.es6");
    $(".section-slider-type-6").length > 0 && require("./page_builder/section_slider_type_6.es6");
    $(".section-image-banner-values").length > 0 && require("./page_builder/section_image_banner_values.es6");
    $(".news__slider").length > 0 && require("./page_builder/section_news.es6");
    $(".news-overview__slider").length > 0 && require("./page_builder/section_news_overview.es6");
    $(".section_slider").length > 0 && require("./page_builder/section_slider.es6");
    $(".rubric-overview__loadmore").length > 0 && require("./page_builder/section_rubric_overview.es6");
    $(".post-section.section-video-block video").length > 0 && require("./post_builder/section_video_block.es6");
    $(".single-news").length > 0 && require("./custom/single_news.es6");
    $(".table-of-contents").length > 0 && require("./page_builder/table-of-contents.es6");
    $(".hero-type-4").length > 0 && require("./page_builder/section_hero_type_4.es6");
    $(".hero-type-5").length > 0 && require("./page_builder/section_hero_type_5.es6");
    $(".hero-type-6").length > 0 && require("./page_builder/section_hero_type_6.es6");
    $(".section-hero-type-7").length > 0 && require("./page_builder/section_hero_type_7.es6");
    $(".section-documents").length > 0 && require("./page_builder/section_documents.es6");
    $(".section-counter-boxes").length > 0 && require("./page_builder/section_counter_boxes.es6");
    $(".section-reviews-slider").length > 0 && require("./page_builder/section_reviews_slider.es6");
    $(".section-slider-downloads").length > 0 && require("./page_builder/section_slider_downloads.es6");
    $(".section-slider-news").length > 0 && require("./page_builder/section_slider_news.es6");
    $(".section-blog-overview .blog-items").length > 0 && require("./page_builder/section_blog_overview.es6");
    $(".section-blog-video").length > 0 && require("./blog_builder/section_blog_video.es6");
    $(".section-blog-share").length > 0 && require("./blog_builder/section_blog_share.es6");
    $(".section-blog-intro").length > 0 && require("./blog_builder/section_blog_intro.es6");
    $(".section-video-parallax-blocks .main-video-box").length > 0 && require("./page_builder/section_video_parallax_blocks.es6");
    $(".simple-text-block").length > 0 && require("./post_builder/section_simple_text_block.es6");
    $(".section-hero-type-8").length > 0 && require("./page_builder/section_hero_type_8.es6");
    $(".section-text-with-qr-code, .section-success-app-banner").length > 0 && require("./page_builder/section_text_with_qr_code.es6");
    $(".section-info-block-type-2").length > 0 && require("./page_builder/section_info_block_type_2.es6");
    $(".section-success-app-banner .phones-parallax").length > 0 && require("./success_page_builder/success_app_banner.es6");

    if($(".multi-step_form:not(.-revision):not(.-new-form):not(.-zaehlerstand)").length > 0) {
        require("./vendor/validation/jquery.validate");
        require("./page_builder/section_multi-step_form.es6");
    }
    if($("#schufa-check").length > 0) {
        require("./vendor/validation/jquery.validate");
        require("./custom/schufa_api.es6");
    }
    if ($(".section-hilfe-kontakt-form, .section-formular").length > 0) {
        require("./page_builder/section_hilfe_kontakt_form.es6");
        require("./custom/custom-ninha-form-validation.es6");
    }
    $(".tariff-api").length > 0 && require("./custom/tariff_api.es6");
    if($(".revision-api").length > 0) {
        require("./vendor/validation/jquery.validate");
        require("./custom/revision_api.es6");
    }
    if($(".revision-api-v2").length > 0) {
        require("./page_builder/section_tooltip_popup.es6")
        require("./vendor/validation/jquery.validate");
        require("./custom/revision_api_v2.es6");
    }
    if($(".new-form-api").length > 0) {
        require("./vendor/validation/jquery.validate");
        require("./custom/new-form.es6");
    }
    if($(".page-template-ad-campaign-template").length > 0) {
        require("./vendor/validation/jquery.validate");
        require("./custom/ad-campaign.es6");
    }
    if($(".page-template-zaehlerstand-melden-template").length > 0) {
        require("./vendor/validation/jquery.validate");
        require("./page_builder/section_tooltip_popup.es6");
        require("./custom/zaehlerstand-melden.es6");
    }
    $(".page-template-success-page-template").length > 0 && require("./custom/success-page.es6");
    $(".ai-preview-information").length > 0 && require("./page_builder/section_ai-preview-information.es6");
    $(".-ai-filling-form").length > 0 && require("./custom/ai-multistep.es6");

    if($(".section-availability-counter").length > 0) {
        require("./vendor/gsap-3.12.2.min.js");
        require("./page_builder/section_availability_counter.es6");
    }
    if($(".umzug-api").length > 0) {
        require("./vendor/validation/jquery.validate");
        require("./page_builder/section_tooltip_popup.es6")
        require("./custom/umzug_api.es6");
    }
    if($(".change-tariff-api").length > 0) {
        require("./vendor/validation/jquery.validate");
        require("./page_builder/section_tooltip_popup.es6")
        require("./custom/change_tariff_api.es6");
    }


    // window.addEventListener("load", function () {
    //     if (Hyphenopoly) {
    //         Hyphenopoly.config({
    //             "paths": {
    //                 "maindir": "/wp-content/themes/gruuun-theme/src/js/vendor/hyphenopoly/",
    //                 "patterndir": "/wp-content/themes/gruuun-theme/src/js/vendor/hyphenopoly/patterns/"
    //             },
    //             "require": {
    //                 "de": "Silbentrennungsalgorithmus",
    //                 "en-us": "Supercalifragilisticexpialidocious",
    //                 "la": "honorificabilitudinitas"
    //             },
    //             "setup": {
    //                 "selectors": {
    //                     ".hyphenopoly": {}
    //                 }
    //             }
    //         });
    //     }
    // });


})(jQuery);